import React from 'react';
import { Ban, Home, RotateCcw } from 'lucide-react';
import { toast } from 'sonner';
import { ConfirmAction } from './ConfirmAction';
import { cancellationApi } from '../../utils/homeSmartCancellations';
import { hsError } from '../../utils/homeSmartCollaborators';

const day = (value) => (value ? new Date(value).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—');

const COPY = {
  bookings: { empty: 'Nessuna prenotazione annullata', restored: 'Prenotazione ripristinata', what: 'la prenotazione' },
  closures: { empty: 'Nessuna chiusura annullata', restored: 'Chiusura ripristinata', what: 'la chiusura' },
};

const Row = ({ kind, row, onRestore }) => {
  const booking = kind === 'bookings';
  return (
    <li className="flex flex-col gap-3 p-4 md:flex-row md:items-center md:justify-between" data-testid={`cancelled-${kind}-row-${row.id}`}>
      <div className="min-w-0 space-y-1">
        <p className="font-medium text-slate-800 break-words" data-testid={`cancelled-${kind}-title-${row.id}`}>
          {booking ? row.guest_name || 'Ospite' : row.reason || 'Chiusura'}
          {booking && row.booking_code && <span className="ml-2 text-xs font-normal text-slate-500">{row.booking_code}</span>}
        </p>
        <p className="flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-slate-500">
          <span className="inline-flex items-center gap-1 notranslate" translate="no"><Home className="h-3.5 w-3.5" />{row.property_name}</span>
          <span data-testid={`cancelled-${kind}-dates-${row.id}`}>{day(booking ? row.check_in : row.start_date)} → {day(booking ? row.check_out : row.end_date)}</span>
          {booking && <span>{row.guests_count || 1} ospiti</span>}
          <span className="text-red-600">Annullata il {day(booking ? row.cancelled_date : row.cancelled_at)}</span>
        </p>
      </div>
      <ConfirmAction testId={`restore-${kind}-${row.id}`} label="Ripristina" icon={RotateCcw}
        title={booking ? 'Ripristinare la prenotazione?' : 'Ripristinare la chiusura?'}
        description={`Torna attiva con le stesse date. Se nel frattempo le date sono state occupate, il ripristino viene bloccato.`}
        confirmLabel="Ripristina" onConfirm={() => onRestore(row)} />
    </li>
  );
};

export const CancelledItems = ({ kind, rows, onChanged }) => {
  const restore = async (row) => {
    try {
      await cancellationApi.restore(kind, row.id);
      toast.success(COPY[kind].restored);
      await onChanged();
    } catch (error) {
      toast.error(hsError(error));
      return false;
    }
  };
  if (!rows.length) {
    return (
      <div className="py-16 text-center" data-testid={`cancelled-${kind}-empty`}>
        <Ban className="mx-auto mb-3 h-10 w-10 text-slate-300" />
        <p className="font-medium text-slate-600">{COPY[kind].empty}</p>
        <p className="mt-1 text-sm text-slate-400">Quando annulli {COPY[kind].what} la trovi qui e puoi ripristinarla.</p>
      </div>
    );
  }
  return (
    <ul className="divide-y divide-slate-100" data-testid={`cancelled-${kind}-list`}>
      {rows.map((row) => <Row key={row.id} kind={kind} row={row} onRestore={restore} />)}
    </ul>
  );
};
